import React from 'react'

import PageLoader from 'components/PageLoader/PageLoader'
import useTextContents from 'common/hooks/useTextContents'


/**
 * Komponent Loadera, prezentowany po etapie weryfikacji w Banku
*/
const BankVerificationWaitingPage = () => {
   const loadersTextContents = useTextContents()
   return ( <PageLoader waitingText={loadersTextContents('loaders.bankVerification')} /> )
}

export default BankVerificationWaitingPage